import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

export const API_BASE = `${BASE}/api`;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatEuro(n) {
  const value = Number(n || 0);
  return value.toLocaleString("de-AT", {
    style: "currency",
    currency: "EUR",
  });
}

export default api;
